export default {
  sideBarIsVisible: false,
};
